import { render } from "./CalenderSvg.vue?vue&type=template&id=6807d16a"
import script from "./CalenderSvg.vue?vue&type=script&lang=js"
export * from "./CalenderSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__